export default "__VITE_ASSET__aDc9v6qK__"